/* istanbul ignore file */

import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  TilesValuesFragmentFragmentDoc,
  type TilesValuesFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

export const tilesDimensionDataMock: TilesValuesFragmentFragment = {
  values: [
    {
      displayText: '(1) not selected / available',
      isSelected: false,
      sku: '7697774729-32',
      availability: {
        state: 'AVAILABLE',
      },
    },
    {
      displayText: '(2) selected / available',
      isSelected: true,
      sku: '7697774729-36',
      availability: {
        state: 'AVAILABLE',
      },
    },
    {
      displayText: '(3) not selected / available',
      isSelected: false,
      sku: '7697774729-40',
      availability: {
        state: 'AVAILABLE',
      },
    },
    {
      displayText: '(4) not selected / available',
      isSelected: false,
      sku: '7697774729-44',
      availability: {
        state: 'AVAILABLE',
      },
    },
    {
      displayText: '(5) not selected / not available',
      isSelected: false,
      sku: '7697774729-48',
      availability: {
        state: 'NOT_AVAILABLE',
      },
    },
    {
      displayText: '(6) not selected / no availability data',
      isSelected: false,
      sku: '7697774729-50',
      availability: null,
    },
    {
      displayText: '(7) selected / not available',
      isSelected: false,
      sku: '7697774729-52',
      availability: {
        state: 'NOT_AVAILABLE',
      },
    },
  ],
};
export const tilesDimensionDataMockIncomplete: TilesValuesFragmentFragment = {
  values: [
    {
      displayText: null,
      isSelected: null,
      sku: '8711923547',
      availability: {
        state: 'AVAILABLE',
      },
    },
  ],
};

export function getTilesDimensionFragmentedData(data?: TilesValuesFragmentFragment) {
  return makeFragmentData(data || tilesDimensionDataMock, TilesValuesFragmentFragmentDoc);
}
